
//loads show/hide settings for StationsPageTable columns from local storage
export function loadUserShownColumns(){

    //check cache
    let savedUserShownColumns = JSON.parse(localStorage.getItem('savedUserShownColumns'))


    //default column settings on cache miss
    if (savedUserShownColumns === null){
        savedUserShownColumns = {
            logo: true,
            market: true,
            sinclair_station_status: true,
            call_sign: true,
            affiliation: true,
            dma_code: true,
            website_vod_assets: true,
            host_or_non_host_for_atsc3: true,
            live: true,
            
            ba_blackout_log_types: false,
            ba_blackout_log_file_name: false,
            wide_orbit_log_recieved_format: false,
            wide_orbit_file_type: false,
            receiving_daily_WO_logs: false,
            atsc3_deployed: false,
            atsc3_deployment_version: false,
            atsc1_vp1_deployed: false,
            atsc1_deployment_version: false,
            atsc3_gsid: false,
            digicaster_ip_addresses: false,
            google_analytics_deployment_verified: false,
            time_zone: false,
            notes: false,
            bsid3_or_tsid1_verance_required_info: false,
            major_minor_virtual_channel_number: false,
            verance_service_id: false,
            signal_signed: false,
            site_content: false,
            headlines_newsletter: false,
            news_app: false,
            weather_newsletter: false,
            weather_app: false,
            station_contacts: false,
        }

        //save default settings in cache
        localStorage.setItem("savedUserColumns", JSON.stringify(savedUserShownColumns))
    }
    return savedUserShownColumns;
};


export function loadUserFilter(){

    //check cache
    let savedUserFilter = JSON.parse(localStorage.getItem('savedUserFilter'))

    //default column settings on cache miss
    if (savedUserFilter === null){
        savedUserFilter = {
            items: [{
                field: "atsc3_deployment_version"
            }],
            logicOperator: "and",
            quickFilterValues: [],
            quickFilterLogicOperator: "and"
        }

        //save default settings in cache
        localStorage.setItem("savedUserColumns", JSON.stringify(savedUserFilter))
    }
    return savedUserFilter;
};


export function loadUserColumnWidths(){

    //check cache
    let savedUserColumnWidths = JSON.parse(localStorage.getItem('savedUserColumnWidths'))

    //default column settings on cache miss
    if (savedUserColumnWidths === null){

        savedUserColumnWidths = {
            id: 130,
            logo: 110,
            call_sign: 100,
            affiliation: 100,
            market: 225,
            sinclair_station_status: 180,
            dma_code: 90,
            website_vod_assets: 200,
            host_or_non_host_for_atsc3: 220,
            ba_blackout_log_types: 205,
            ba_blackout_log_file_name: 205,
            wide_orbit_log_recieved_format: 240,
            wide_orbit_file_type: 175,
            receiving_daily_WO_logs: 200,
            atsc3_deployed: 220,
            atsc3_deployment_version: 205,
            atsc1_vp1_deployed: 200,
            atsc3_gsid: 200,
            digicaster_ip_addresses: 180,
            google_analytics_deployment_verified: 275,
            time_zone: 90,
            notes: 200,
            bsid3_or_tsid1_verance_required_info: 330,
            major_minor_virtual_channel_number: 270,
            verance_service_id: 150,
            signal_signed: 125,
            site_content: 110,
            headlines_newsletter: 175,
            news_app: 100,
            weather_newsletter: 150,
            weather_app: 125,
            station_contacts: 150,
            live: 110,
        }

        //save default settings in cache
        localStorage.setItem("savedUserColumnWidths", JSON.stringify(savedUserColumnWidths))
    }
    return savedUserColumnWidths;
}


